export const PLAYER_PROFILE_STORAGE_KEY = 'towerarena.com.player-profile';
export const DEFAULT_PLAYER_NAME = 'Игрок';
export const MAX_PLAYER_NAME_LENGTH = 20;

export interface PlayerProfile {
  schemaVersion: 1;
  displayName: string;
}

export function normalizePlayerName(value: unknown): string {
  if (typeof value !== 'string') return DEFAULT_PLAYER_NAME;
  const normalized = value
    .normalize('NFKC')
    .replace(/[\p{Cc}\p{Cf}]/gu, '')
    .replace(/\s+/gu, ' ')
    .trim();
  return Array.from(normalized).slice(0, MAX_PLAYER_NAME_LENGTH).join('') || DEFAULT_PLAYER_NAME;
}

export function parsePlayerProfile(raw: string | null): PlayerProfile {
  if (!raw) return { schemaVersion: 1, displayName: DEFAULT_PLAYER_NAME };
  try {
    const value = JSON.parse(raw) as Record<string, unknown>;
    return { schemaVersion: 1, displayName: normalizePlayerName(value.displayName) };
  } catch {
    return { schemaVersion: 1, displayName: DEFAULT_PLAYER_NAME };
  }
}

export function savePlayerProfile(storage: Pick<Storage, 'setItem'>, profile: PlayerProfile): boolean {
  try {
    storage.setItem(PLAYER_PROFILE_STORAGE_KEY, JSON.stringify(profile));
    return true;
  } catch {
    return false;
  }
}
